export const config = {
    usersApi : 'https://65615e6adcd355c08323c948.mockapi.io',
    ordersApi : 'https://65630c3eee04015769a6bb77.mockapi.io',
    packageApi: 'https://655e29389f1e1093c59a9ffc.mockapi.io',
    feedbackApi: 'https://65615e6adcd355c08323c948.mockapi.io',
}